import type { TovVersionResponse } from "contracts/api/client-tov/version.responses";
import {
  TOV_RULE_SEVERITIES,
  TOV_RULE_TYPES,
  TOV_SCOPE_TYPES,
} from "contracts/enums/tov-voice";
import { For, Show } from "solid-js";
import { TOV_FIELD_KIND } from "../../enums/tov";
import { type CardEditProps, EditableCard, type FieldSpec } from "./EditForms";
import { Group } from "./Group";
import { CardGrid } from "./primitives";

const RULE_FIELDS: FieldSpec[] = [
  {
    name: "ruleType",
    label: "Type",
    kind: TOV_FIELD_KIND.SELECT,
    options: TOV_RULE_TYPES,
  },
  {
    name: "severity",
    label: "Severity",
    kind: TOV_FIELD_KIND.SELECT,
    options: TOV_RULE_SEVERITIES,
  },
  {
    name: "scopeType",
    label: "Scope",
    kind: TOV_FIELD_KIND.SELECT,
    options: TOV_SCOPE_TYPES,
  },
  {
    name: "scopeKey",
    label: "Scope key",
    kind: TOV_FIELD_KIND.TEXT,
    optional: true,
  },
  { name: "title", label: "Title", kind: TOV_FIELD_KIND.TEXT },
  {
    name: "description",
    label: "Description",
    kind: TOV_FIELD_KIND.TEXT,
    grow: true,
  },
  {
    name: "rationale",
    label: "Rationale",
    kind: TOV_FIELD_KIND.TEXT,
    optional: true,
    grow: true,
  },
];

export function RuleCards(props: {
  version: TovVersionResponse;
  edit: CardEditProps;
}) {
  return (
    <Group title="Rules" empty={props.version.rules.length === 0}>
      <CardGrid>
        <For each={props.version.rules}>
          {(rule) => (
            <EditableCard
              title={rule.title}
              tag={rule.severity}
              editable={props.edit.editable}
              fields={RULE_FIELDS}
              initial={{
                ruleType: rule.ruleType,
                severity: rule.severity,
                scopeType: rule.scopeType,
                scopeKey: rule.scopeKey ?? undefined,
                title: rule.title,
                description: rule.description,
                rationale: rule.rationale ?? undefined,
                displayOrder: rule.displayOrder,
              }}
              onSave={(values) => props.edit.onEdit("rules", rule.id, values)}
              onDelete={() => props.edit.onDelete("rules", rule.id)}
            >
              <div class="tov-tags">
                <span class="tov-chip muted">{rule.ruleType}</span>
                <span class="tov-chip muted">{rule.scopeType}</span>
              </div>
              <p class="tov-desc">{rule.description}</p>
              <Show when={rule.rationale}>
                <p class="tov-sub">{rule.rationale}</p>
              </Show>
            </EditableCard>
          )}
        </For>
      </CardGrid>
    </Group>
  );
}
